import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import PropTypes from "prop-types";
import React, { useState, useRef, useEffect } from "react";
import analytics from "web/script/analytics/analytics";
import Button from "web/react/components/button/button";
import LeadLink from "web/react/components/lead-link/lead-link";
import { gettext } from "web/script/modules/django-i18n";
import classnames from "classnames";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import styles from "./product-description-express-checkout-size-select.css";

function ProductDescriptionExpressCheckoutSizeSelect(_ref) {
  var sizes = _ref.sizes,
      leadUrl = _ref.leadUrl,
      productId = _ref.productId;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setOpen = _useState2[1];

  var sizeSelect = useRef(null);

  function handler(e) {
    if (e.target != sizeSelect.current) {
      handleBlur();
    }
  }

  useEffect(function () {
    if (isOpen) {
      document.addEventListener("click", handler);
    }

    return function () {
      document.removeEventListener("click", handler);
    };
  });

  function toggleList() {
    setOpen(!isOpen);
  }

  function handleButtonClick() {
    setOpen(true);
    analytics.event("express_checkout", "select_box_clicked");
  }

  function handleSizeClick() {
    toggleList();
    analytics.event("express_checkout", "changed_size");
  }

  function handleBlur() {
    setOpen(false);
  }

  var sizeList = sizes.map(function (size, i) {
    return React.createElement("li", {
      key: i,
      onClick: handleSizeClick
    }, size.human_size + " - " + size.min_price);
  });
  var buttonLabel = sizes[0].human_size + " - " + sizes[0].min_price;
  return React.createElement("div", {
    className: classnames(styles.size_select, _defineProperty({}, styles.is_open, isOpen))
  }, React.createElement(Button, {
    className: styles.size_select_button,
    onClick: handleButtonClick,
    fullWidth: true,
    styleType: "secondary"
  }, buttonLabel, React.createElement(SVGIcon, {
    className: styles.chevron,
    name: "round-chevron",
    rotate: isOpen ? -90 : 90
  })), React.createElement("ul", {
    className: styles.size_select_list,
    ref: sizeSelect
  }, sizeList, React.createElement("li", null, React.createElement(LeadLink, {
    href: leadUrl,
    productId: productId,
    openInNewTab: true,
    reason: "click-to-see-more-sizes",
    afterOnClick: toggleList
  }, gettext("product.buy_area.see_more_sizes")))));
}

export default ProductDescriptionExpressCheckoutSizeSelect;
ProductDescriptionExpressCheckoutSizeSelect.propTypes = {
  leadUrl: PropTypes.string.isRequired,
  productId: PropTypes.string.isRequired,
  sizes: PropTypes.arrayOf(PropTypes.shape({
    option_value: PropTypes.shape({
      link_id: PropTypes.string,
      raw_size: PropTypes.string,
      icon: PropTypes.bool
    }),
    human_size: PropTypes.string,
    raw_size: PropTypes.string,
    min_price: PropTypes.string
  }))
};